'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdTraffic = function MdTraffic(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20 15c1.9 0 3.4-1.6 3.4-3.4 0-1.8-1.6-3.2-3.4-3.2-1.9 0-3.4 1.4-3.4 3.2 0 1.8 1.5 3.4 3.4 3.4z m0 8.4c1.9 0 3.4-1.6 3.4-3.4s-1.6-3.4-3.4-3.4c-1.9 0-3.4 1.6-3.4 3.4s1.5 3.4 3.4 3.4z m0 8.2c1.9 0 3.4-1.4 3.4-3.2s-1.6-3.4-3.4-3.4c-1.9 0-3.4 1.6-3.4 3.4s1.5 3.2 3.4 3.2z m13.4-15c0 3.2-2.1 5.7-5 6.5v1.9h5c0 3.1-2.1 5.6-5 6.4v2c0 0.9-0.8 1.6-1.8 1.6h-13.2c-1 0-1.8-0.7-1.8-1.6v-2c-2.8-0.8-5-3.3-5-6.4h5v-1.9c-2.8-0.8-5-3.3-5-6.5h5v-1.8c-2.8-0.8-5-3.3-5-6.4h5v-1.8c0-0.9 0.8-1.6 1.8-1.6h13.2c1 0 1.8 0.7 1.8 1.6v1.8h5c0 3.1-2.1 5.6-5 6.4v1.8h5z' })
        )
    );
};

exports.default = MdTraffic;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/traffic.js
// module id = 2011
// module chunks = 168707334958949